import { useState } from "react";
import { Snackbar, Alert, Slide, SlideProps, SnackbarCloseReason } from "@mui/material";
import { AlertMsg, Severity } from "type";

const alertHideDuration = 4000;
const alertEnterTime = 300;
const alertAppearTime = 0;
const alertExitTime = 250;

type Props = {
  overrideHandleSuccessClose: () => void;
};

const slideTransition = (props: SlideProps) => <Slide {...props} direction='down'/>



const defaultAlertMsg: AlertMsg = {msg: '', severity: 'success'};

/**
 * 成功時のアラート
 * @param props コンポーネントのプロップス
 * @returns 状態更新関数と成功アラートのコンポーネント
 */
export default function useSuccessAlert(props?: Props) {
  // const [isSuccessAlertOpen, setIsSuccessAlertOpen] = useState(false);
  const [snack, setSnack] = useState({open: false, key: 0});
  const [successAlertMsg, setSuccessAlertMsg] = useState<AlertMsg>(defaultAlertMsg);
  const handleSuccessClose = props?.overrideHandleSuccessClose ?? ((
    _e?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") return;
    // setIsSuccessAlertOpen(false);
    setSnack(s => ({...s, open: false})); // 閉じるだけなので更新しない
    setTimeout(() => {
      setSuccessAlertMsg(defaultAlertMsg);
    }, alertExitTime);
  });
  const showAlert = (msg: string, severity?: Severity) => {
    // setIsSuccessAlertOpen(true);
    setSnack(s => ({open: true, key: s.key + 1})); // 強制更新し、新しいAlertを出す
    setSuccessAlertMsg({msg, severity})
  };

  return {
    showAlert,
    successAlertRender: () => (
      <Snackbar
        key={snack.key}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        transitionDuration={{
          enter: alertEnterTime,
          appear: alertAppearTime,
          exit: alertExitTime
        }}
        TransitionComponent={slideTransition}
        open={snack.open}
        autoHideDuration={alertHideDuration}
        onClose={handleSuccessClose}
      >
        <Alert onClose={handleSuccessClose} severity={successAlertMsg.severity ?? 'success'}>
          {successAlertMsg.msg}
        </Alert>
      </Snackbar>
    ),
    alertExitTime
  }
}










